export function checkForRequiredScope(info, currentScope) {
  if (!info.requiredScopes?.length) {
    return true;
  }
  return info.requiredScopes.includes(currentScope);
}